module.exports = __webpack_public_path__ + "static/media/27OCHA1.93240483.jpg";